const shop = {
  shopname: "Shop name",
  contacts: "Contacts",
  shopnamewidth: "90px",
  contactswidth: "65px",
  mobilewidth: "70px",
  logo: "LOGO",
  mobile: "Contact number",
  shoptime: "Business time",
  address: "Address",
  addshop: "Add shops",
  editshop: "Edit shops",
  baseMessage: "Basic information",
  otherMessage: "Other information",
  jianjie: "Business description",
  uploadImg: "Upload shop photos",
  formLeftWidth: "120px",
  formDetailWidth: "130px",
  photo: "Please upload JPG/JPEG/PNG/GIF/SVG/BMP images",
  tips: "Please enter",
  tipsLength: "Character length cannot exceed",
  uploadLOGO: "Upload a LOGO",
  detailTitle: "Shop for details",
  shopLink: "Shop link"
} 
export default shop